import React, { useState, useMemo, useCallback, useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  Input,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import Pagination from "components/pagination";
// FundsTable will be created in components/FundsTable.js
import FundsTable from "./components/FundsTable";
import FundingDetails from "./components/FundingDetails";
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllFundedInvoices, fetchAdminInvoiceDetails } from 'features/invoices/actions';

const columnsDataFunds = [
  { Header: "System ID", accessor: "invoiceNumber" },
  { Header: "Invoice Number", accessor: "referenceNumber" },
  { Header: "Funded Amount", accessor: "fundedAmount" },
  { Header: "Remaining Balance", accessor: "remainingAmount" },
  { Header: "Status", accessor: "status" },
  { Header: "Date", accessor: "date" },
  { Header: "Actions", accessor: "actions" },
];

const tabOptions = ["All", "Partial", "Settled"];

const Funding = () => {
  const dispatch = useDispatch();
  const { fundedInvoices, loading } = useSelector((state) => state.invoices);
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("All");
  const bgInput = useColorModeValue("transparent", "navy.900");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedFund, setSelectedFund] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchAllFundedInvoices({
        page: currentPage,
        limit: 0,
        searchTerm
      }));
    };

    const debounced = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(debounced);
  }, [dispatch, currentPage, itemsPerPage, searchTerm]);

  const filteredData = useMemo(() => {
    return fundedInvoices || [];
  }, [fundedInvoices]);

  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const currentPageData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, currentPage, itemsPerPage]);

  const handlePageChange = useCallback((data, page, limit) => {
    setCurrentPage(page);
    setItemsPerPage(limit);
  }, []);

  const handleRowClick = async (fund) => {
    try {
      await dispatch(fetchAdminInvoiceDetails(fund._id)).unwrap();
      setSelectedFund(fund);
      setShowDetails(true);
    } catch (error) {
      console.error('Error fetching invoice details:', error);
    }
  };

  const handleBack = () => {
    // dispatch(clearSelectedInvoice());
    setShowDetails(false);
    setSelectedFund(null);
  };

  return (
    <>
      <Card borderRadius="0" p="0">
        {showDetails ? (
          <FundingDetails
            onBack={handleBack}
            fund={selectedFund}
          />
        ) : (
          <Flex direction="column">
            <Flex justify="space-between" align="center" mb={4}>
              <Text color={textColor} fontSize="30px" fontWeight="700">
                Funding
              </Text>
              <Flex gap={4}>
                <Input
                  placeholder="Search"
                  borderRadius="4px"
                  size="md"
                  width="218px"
                  height="40px"
                  bg={bgInput}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {/* <Button colorScheme="gray" variant="outline" height="40px">
                  Export Invoice
                </Button>
                <Button colorScheme="gray" variant="outline" height="40px">
                  Import Invoice
                </Button> */}
              </Flex>
            </Flex>
            <Card borderRadius="8px" boxShadow="0px 0px 12px 0px #0000001A">
              <FundsTable
                columnsData={columnsDataFunds}
                tableData={currentPageData}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                onRowClick={handleRowClick}
              />
              <Flex
                justify="space-between"
                align="center"
                px={4}
                py={4}
                borderTop="1px solid"
                borderColor="gray.200">
                <Pagination
                  data={filteredData}
                  onPageChange={handlePageChange}
                  initialItemsPerPage={itemsPerPage}
                  currentPage={currentPage}
                  totalItems={totalItems}
                  totalPages={totalPages}
                  hasMoreData={currentPage < totalPages}
                />
              </Flex>
            </Card>
          </Flex>
        )}
      </Card>
    </>
  );
};

export default Funding;
